import { jsx as m, jsxs as E } from "react/jsx-runtime";
import * as g from "react";
import { useState as J, useEffect as Q, useId as he, useCallback as F, createElement as ge } from "react";
import { a as pe, c as N } from "./index-eoE_jzLb.js";
import { u as K } from "./index-DoOsnuB6.js";
import { P as $, c as xe } from "./index-D8UDu4KA.js";
import { c as be, u as Se } from "./index-Dn75bnUs.js";
import { u as ye } from "./index-BZPx6jYI.js";
import { u as ve } from "./index-4vbonZJj.js";
import { c as q } from "./clsx-OuTLNxxd.js";
import { I as Z } from "./Input-CP1rNW1u.js";
import { L as _e } from "./Label--mSFXd1M.js";
import './Slider.css';function ee(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var te = ["PageUp", "PageDown"], ne = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], oe = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, M = "Slider", [U, we, Ce] = be(M), [ie] = xe(M, [
  Ce
]), [Pe, O] = ie(M), re = g.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: o = 0,
      max: a = 100,
      step: l = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: f = [o],
      value: S,
      onValueChange: n = () => {
      },
      onValueCommit: u = () => {
      },
      inverted: b = !1,
      form: P,
      ..._
    } = e, p = g.useRef(/* @__PURE__ */ new Set()), h = g.useRef(0), C = s === "horizontal" ? Ie : Re, [y = [], d] = pe({
      prop: S,
      defaultProp: f,
      onChange: (x) => {
        var I;
        (I = [...p.current][h.current]) == null || I.focus(), n(x);
      }
    }), v = g.useRef(y);
    function H(x) {
      const B = ze(y, x);
      V(x, B);
    }
    function k(x) {
      V(x, h.current);
    }
    function A() {
      const x = v.current[h.current];
      y[h.current] !== x && u(y);
    }
    function V(x, B, { commit: I } = { commit: !1 }) {
      const D = Me(l), L = ke(Math.round((x - o) / l) * l + o, D), T = ee(L, [o, a]);
      d((W = []) => {
        const z = De(W, T, B);
        if (Ne(z, c * l)) {
          h.current = z.indexOf(T);
          const G = String(z) !== String(W);
          return G && I && u(z), G ? z : W;
        } else
          return W;
      });
    }
    return /* @__PURE__ */ m(
      Pe,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: i,
        min: o,
        max: a,
        valueIndexToChangeRef: h,
        thumbs: p.current,
        values: y,
        orientation: s,
        form: P,
        children: /* @__PURE__ */ m(U.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(U.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
          C,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ..._,
            ref: t,
            onPointerDown: N(_.onPointerDown, () => {
              i || (v.current = y);
            }),
            min: o,
            max: a,
            inverted: b,
            onSlideStart: i ? void 0 : H,
            onSlideMove: i ? void 0 : k,
            onSlideEnd: i ? void 0 : A,
            onHomeKeyDown: () => !i && V(o, 0, { commit: !0 }),
            onEndKeyDown: () => !i && V(a, y.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: x, direction: B }) => {
              if (!i) {
                const L = te.includes(x.key) || x.shiftKey && ne.includes(x.key) ? 10 : 1, T = h.current, W = y[T], z = l * L * B;
                V(W + z, T, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
re.displayName = M;
var [se, ae] = ie(M, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Ie = g.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      dir: a,
      inverted: l,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: c,
      onStepKeyDown: f,
      ...S
    } = e, [n, u] = g.useState(null), b = K(t, (C) => u(C)), P = g.useRef(void 0), _ = Se(a), p = _ === "ltr", h = p && !l || !p && l;
    function R(C) {
      const y = P.current || n.getBoundingClientRect(), d = [0, y.width], H = X(d, h ? [r, o] : [o, r]);
      return P.current = y, H(C - y.left);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "left" : "right",
        endEdge: h ? "right" : "left",
        direction: h ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ m(
          le,
          {
            dir: _,
            "data-orientation": "horizontal",
            ...S,
            ref: b,
            style: {
              ...S.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (C) => {
              const y = R(C.clientX);
              s == null || s(y);
            },
            onSlideMove: (C) => {
              const y = R(C.clientX);
              i == null || i(y);
            },
            onSlideEnd: () => {
              P.current = void 0, c == null || c();
            },
            onStepKeyDown: (C) => {
              const d = oe[h ? "from-left" : "from-right"].includes(C.key);
              f == null || f({ event: C, direction: d ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Re = g.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      inverted: a,
      onSlideStart: l,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: c,
      ...f
    } = e, S = g.useRef(null), n = K(t, S), u = g.useRef(void 0), b = !a;
    function P(_) {
      const p = u.current || S.current.getBoundingClientRect(), h = [0, p.height], C = X(h, b ? [o, r] : [r, o]);
      return u.current = p, C(_ - p.top);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: b ? "bottom" : "top",
        endEdge: b ? "top" : "bottom",
        size: "height",
        direction: b ? 1 : -1,
        children: /* @__PURE__ */ m(
          le,
          {
            "data-orientation": "vertical",
            ...f,
            ref: n,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (_) => {
              const p = P(_.clientY);
              l == null || l(p);
            },
            onSlideMove: (_) => {
              const p = P(_.clientY);
              s == null || s(p);
            },
            onSlideEnd: () => {
              u.current = void 0, i == null || i();
            },
            onStepKeyDown: (_) => {
              const h = oe[b ? "from-bottom" : "from-top"].includes(_.key);
              c == null || c({ event: _, direction: h ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), le = g.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: l,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: c,
      ...f
    } = e, S = O(M, r);
    return /* @__PURE__ */ m(
      $.span,
      {
        ...f,
        ref: t,
        onKeyDown: N(e.onKeyDown, (n) => {
          n.key === "Home" ? (s(n), n.preventDefault()) : n.key === "End" ? (i(n), n.preventDefault()) : te.concat(ne).includes(n.key) && (c(n), n.preventDefault());
        }),
        onPointerDown: N(e.onPointerDown, (n) => {
          const u = n.target;
          u.setPointerCapture(n.pointerId), n.preventDefault(), S.thumbs.has(u) ? u.focus() : o(n);
        }),
        onPointerMove: N(e.onPointerMove, (n) => {
          n.target.hasPointerCapture(n.pointerId) && a(n);
        }),
        onPointerUp: N(e.onPointerUp, (n) => {
          const u = n.target;
          u.hasPointerCapture(n.pointerId) && (u.releasePointerCapture(n.pointerId), l(n));
        })
      }
    );
  }
), ce = "SliderTrack", de = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = O(ce, r);
    return /* @__PURE__ */ m(
      $.span,
      {
        "data-disabled": a.disabled ? "" : void 0,
        "data-orientation": a.orientation,
        ...o,
        ref: t
      }
    );
  }
);
de.displayName = ce;
var Y = "SliderRange", ue = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = O(Y, r), l = ae(Y, r), s = g.useRef(null), i = K(t, s), c = a.values.length, f = a.values.map(
      (u) => fe(u, a.min, a.max)
    ), S = c > 1 ? Math.min(...f) : 0, n = 100 - Math.max(...f);
    return /* @__PURE__ */ m(
      $.span,
      {
        "data-orientation": a.orientation,
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: i,
        style: {
          ...e.style,
          [l.startEdge]: S + "%",
          [l.endEdge]: n + "%"
        }
      }
    );
  }
);
ue.displayName = Y;
var j = "SliderThumb", me = g.forwardRef(
  (e, t) => {
    const r = we(e.__scopeSlider), [o, a] = g.useState(null), l = K(t, (i) => a(i)), s = g.useMemo(
      () => o ? r().findIndex((i) => i.ref.current === o) : -1,
      [r, o]
    );
    return /* @__PURE__ */ m(Ve, { ...e, ref: l, index: s });
  }
), Ve = g.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, index: o, name: a, ...l } = e, s = O(j, r), i = ae(j, r), [c, f] = g.useState(null), S = K(t, (R) => f(R)), n = c ? s.form || !!c.closest("form") : !0, u = ve(c), b = s.values[o], P = b === void 0 ? 0 : fe(b, s.min, s.max), _ = He(o, s.values.length), p = u == null ? void 0 : u[i.size], h = p ? Ee(p, P, i.direction) : 0;
    return g.useEffect(() => {
      if (c)
        return s.thumbs.add(c), () => {
          s.thumbs.delete(c);
        };
    }, [c, s.thumbs]), /* @__PURE__ */ E(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${P}% + ${h}px)`
        },
        children: [
          /* @__PURE__ */ m(U.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
            $.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || _,
              "aria-valuemin": s.min,
              "aria-valuenow": b,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...l,
              ref: S,
              style: b === void 0 ? { display: "none" } : e.style,
              onFocus: N(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          n && /* @__PURE__ */ m(
            Be,
            {
              name: a ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: b
            },
            o
          )
        ]
      }
    );
  }
);
me.displayName = j;
var Be = (e) => {
  const { value: t, ...r } = e, o = g.useRef(null), a = ye(t);
  return g.useEffect(() => {
    const l = o.current, s = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(s, "value").set;
    if (a !== t && c) {
      const f = new Event("input", { bubbles: !0 });
      c.call(l, t), l.dispatchEvent(f);
    }
  }, [a, t]), /* @__PURE__ */ m("input", { style: { display: "none" }, ...r, ref: o, defaultValue: t });
};
function De(e = [], t, r) {
  const o = [...e];
  return o[r] = t, o.sort((a, l) => a - l);
}
function fe(e, t, r) {
  const l = 100 / (r - t) * (e - t);
  return ee(l, [0, 100]);
}
function He(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function ze(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((a) => Math.abs(a - t)), o = Math.min(...r);
  return r.indexOf(o);
}
function Ee(e, t, r) {
  const o = e / 2, l = X([0, 50], [0, o]);
  return (o - l(t) * r) * r;
}
function We(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function Ne(e, t) {
  if (t > 0) {
    const r = We(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function X(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function Me(e) {
  return (String(e).split(".")[1] || "").length;
}
function ke(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var Ae = re, Te = de, Ke = ue, qe = me;
const $e = "320px", Oe = "600px", Le = "1025px", Fe = "_output_igqbd_37", Ue = "_sliderWrapper_igqbd_55", Ye = "_label_igqbd_67", je = "_labelContainer_igqbd_71", Xe = "_controlsWrapper_igqbd_76", Ge = "_inputsContainer_igqbd_83", Je = "_inputWrapper_igqbd_90", Qe = "_sliderContainer_igqbd_109", Ze = "_shouldShowBackground_igqbd_115", et = "_track_igqbd_120", tt = "_slider_igqbd_55", nt = "_range_igqbd_142", ot = "_thumb_igqbd_149", it = "_noValue_igqbd_162", rt = "_sliderInput_igqbd_182", w = {
  mobile: $e,
  "mobile-wide": "480px",
  tablet: Oe,
  "tablet-wide": "800px",
  desktop: Le,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  "size-s": "_size-s_igqbd_32",
  output: Fe,
  "size-m": "_size-m_igqbd_43",
  sliderWrapper: Ue,
  label: Ye,
  labelContainer: je,
  controlsWrapper: Xe,
  inputsContainer: Ge,
  inputWrapper: Je,
  sliderContainer: Qe,
  shouldShowBackground: Ze,
  track: et,
  slider: tt,
  range: nt,
  thumb: ot,
  noValue: it,
  sliderInput: rt
}, xt = ({
  className: e,
  label: t,
  shouldShowBackground: r = !1,
  shouldShowLabel: o = !1,
  size: a = "m",
  unit: l,
  withInputs: s = !1,
  ...i
}) => {
  const { max: c = 1 / 0, min: f = -1 / 0, onValueChange: S } = i, [n, u] = J(i.value || i.defaultValue || [0]), [b, P] = J([]);
  Q(() => {
    i.value && u(i.value);
  }, [i.value]), Q(() => {
    P(n.map((d) => String(d)));
  }, [n]);
  const _ = n && n.length <= 1 && n[0] === 0, p = he(), h = `${p}-output`, R = F(
    (d, v) => {
      var B;
      P((I) => {
        const D = [...I];
        return D[d] = v, D;
      });
      const H = parseInt(v, 10);
      if (isNaN(H))
        return;
      const { max: k = 1 / 0, min: A = -1 / 0 } = i, V = Math.max(A, Math.min(H, k));
      if (d === 0 && V > n[1] || d === 1 && V < n[0])
        return;
      const x = [...n];
      x[d] = V, x.some((I, D) => I !== n[D]) && (u(x), (B = i.onValueChange) == null || B.call(i, x));
    },
    [f, c, S, i, n]
  ), C = F(
    (d) => {
      const v = parseInt(b[d], 10), H = n[d === 0 ? 1 : 0], k = isNaN(v), A = v < (f ?? -1 / 0), V = v > (c ?? 1 / 0), x = d === 0 && v > H || d === 1 && v < H;
      k || A || V || x ? P((I) => {
        const D = [...I];
        return D[d] = String(n[d]), D;
      }) : R(d, String(v));
    },
    [b, n, f, c, R]
  ), y = F(
    (d) => {
      u(d), S == null || S(d);
    },
    [S]
  );
  return /* @__PURE__ */ E("div", { className: q(w.sliderWrapper, w[`size-${a}`]), "data-cxy-name": "slider", children: [
    o && /* @__PURE__ */ m("div", { className: w.labelContainer, children: /* @__PURE__ */ m(_e, { className: w.label, htmlFor: p, size: "s", children: t }) }),
    /* @__PURE__ */ E("div", { className: w.controlsWrapper, children: [
      /* @__PURE__ */ E(
        "div",
        {
          className: q(w.sliderContainer, {
            [w.shouldShowBackground]: r
          }),
          children: [
            /* @__PURE__ */ E(
              Ae,
              {
                id: p,
                ...!o && { "aria-label": t },
                "aria-describedby": h,
                className: q(w.slider, e),
                ...i,
                onValueChange: y,
                value: n,
                children: [
                  /* @__PURE__ */ m(Te, { className: w.track, children: /* @__PURE__ */ m(Ke, { className: w.range }) }),
                  n.map((d, v) => /* @__PURE__ */ ge(
                    qe,
                    {
                      ...!o && { "aria-label": t },
                      className: q(w.thumb, { [w.noValue]: _ }),
                      key: `${t}-thumb-${v}`
                    }
                  ))
                ]
              }
            ),
            !s && /* @__PURE__ */ E("p", { className: w.output, "data-testid": "slider-output", id: h, children: [
              n.map((d, v) => /* @__PURE__ */ m("span", { children: `${n[v]}${v === n.length - 1 ? "" : "-"}` }, `${t}-output-${v}`)),
              l || ""
            ] })
          ]
        }
      ),
      s && n.length === 2 && /* @__PURE__ */ E("div", { className: w.inputsContainer, children: [
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: n[1],
            min: f,
            onBlur: () => C(0),
            onChange: (d) => R(0, d.target.value),
            type: "number",
            value: b[0] ?? ""
          }
        ) }),
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: c,
            min: n[0],
            onBlur: () => C(1),
            onChange: (d) => R(1, d.target.value),
            type: "number",
            value: b[1] ?? ""
          }
        ) })
      ] })
    ] })
  ] });
};
export {
  xt as S
};
